export const useGetDayListOfWeek = () => {
    const weekDays = [
        {
            id: 0,
            label: 'Monday',
            value: 'monday'
        },
        {
            id: 1,
            label: 'Tuesday',
            value: "tuesday",
        },
        {
            id: 2,
            label: 'Wednesday',
            value: "wednesday",
        },
        {
            id: 3,
            label: 'Thursday',
            value: "thursday",
        },
        {
            id: 4,
            label: 'Friday',
            value: "friday",
        },
        {
            id: 5,
            label: 'Saturday',
            value: "saturday",
        },
        {
            id: 6,
            label: 'Sunday',
            value: "sunday",
        },
    ]

    return { weekDays }

}